export const PhonePrefixSelectionFeatureConstant = {
    shopping: 'shopping'
}